"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = save;

var _element = require("@wordpress/element");

var _classnames = _interopRequireDefault(require("classnames"));

var _blockEditor = require("@wordpress/block-editor");

/**
 * External dependencies
 */

/**
 * WordPress dependencies
 */
function save(_ref) {
  let {
    attributes
  } = _ref;
  const {
    align,
    value,
    citation
  } = attributes;
  const className = (0, _classnames.default)({
    [`has-text-align-${align}`]: align
  });
  return (0, _element.createElement)("blockquote", _blockEditor.useBlockProps.save({
    className
  }), (0, _element.createElement)(_blockEditor.RichText.Content, {
    multiline: true,
    value: value
  }), !_blockEditor.RichText.isEmpty(citation) && (0, _element.createElement)(_blockEditor.RichText.Content, {
    tagName: "cite",
    value: citation
  }));
}
//# sourceMappingURL=save.js.map